// extracted by mini-css-extract-plugin
module.exports = {"leftContainer":"login_leftContainer__hQCmU","rightContainer":"login_rightContainer__FVT81","rightContent":"login_rightContent__HPBBP"};